<template>
  <div class="fixed-plugin" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown">
        <i class="fa fa-cog fa-2x" @click="toggleDropDown"></i>
      </a>
      <ul class="dropdown-menu" :class="{ show: isOpen }">
        <li class="header-title">Zero position</li>

        <md-field v-if="permissions >= 4">
          <md-select v-model="local_zeroPosition">
            <md-option value="0">Start top</md-option>
            <md-option value="90">Start right</md-option>
            <md-option value="180">Start bottom</md-option>
            <md-option value="270">Start left</md-option>
          </md-select>
        </md-field>

        <li class="header-title">Direction of rotation</li>

        <md-field v-if="permissions >= 3">
          <md-select v-model="local_clockWiseDirection">
            <md-option value="true">Clockwise</md-option>
            <md-option value="false">Counterclockwise</md-option>
          </md-select>
        </md-field>

        <li class="button-container">
          <div class>
            <md-button class="md-success md-block" @click="saveSettings">{{$lang.keys.save}}</md-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    permissions: {
      type: Number,
      default: 0
    },
    zeroPosition: {
      type: String,
      default: "0"
    },
    clockWiseDirection: {
      type: String,
      default: "true"
    }
  },

  data() {
    return {
      isOpen: false,
      local_zeroPosition: null,
      local_clockWiseDirection: null
    };
  },

  mounted() {
    this.local_zeroPosition = this.zeroPosition;
    this.local_clockWiseDirection = this.clockWiseDirection;

    this.$nextTick(() => {
      this.saveSettings();
    });
  },

  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },

    closeDropDown() {
      this.isOpen = false;
    },

    saveSettings() {
      this.$emit("onUpdate", {
        zeroPosition: Number(this.local_zeroPosition),
        clockWiseDirection:
          this.local_clockWiseDirection === "true" ? false : true
      });
    }
  }
};
</script>

<style scoped>
.fixed-plugin {
  top: 150px;
}

.centered-row {
  display: flex;
  height: 100%;
  align-items: center;
}

.button-container .btn {
  margin-right: 10px;
}

.centered-buttons {
  display: flex;
  justify-content: center;
}
</style>
